/* FL FIT listicle (IT) – ATC + sticky bar. Vanilla, no deps.
   ATC = same path as the IT PDP: window.fnCartDrawer.add(FormData{id,quantity})
   -> /cart/add.js, applies the drawer offer logic and opens the IT cart drawer.
   Fallback (no drawer or mode cart/checkout): /cart/add.js, then redirect. */
(function () {
  if (window.flFit) return;
  var d = document;

  function offerEl() { return d.querySelector('[data-flf-offer]'); }
  function current(el) {
    var o = offerEl();
    var r = o && o.querySelector('input[data-flf-opt]:checked');
    if (r) return { id: r.getAttribute('data-variant'), qty: parseInt(r.value, 10) || 1, mode: o.getAttribute('data-after') || 'drawer' };
    return {
      id: el && el.getAttribute('data-variant'),
      qty: parseInt(el && el.getAttribute('data-qty'), 10) || 1,
      mode: (el && el.getAttribute('data-after')) || 'drawer'
    };
  }
  function nativePost(id, qty, mode) {
    var f = d.createElement('form');
    f.method = 'post'; f.action = '/cart/add'; f.style.display = 'none';
    f.innerHTML = '<input name="id" value="' + id + '"><input name="quantity" value="' + qty + '">' +
      (mode === 'checkout' ? '<input name="return_to" value="/checkout">' : '');
    d.body.appendChild(f); f.submit();
  }
  function add(el) {
    var c = current(el);
    if (!c.id) return;
    var fd = new FormData();
    fd.append('id', c.id);
    fd.append('quantity', c.qty);
    if (c.mode === 'drawer' && window.fnCartDrawer && typeof window.fnCartDrawer.add === 'function') {
      return window.fnCartDrawer.add(fd);
    }
    if (el) el.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { location.href = c.mode === 'checkout' ? '/checkout' : '/cart'; })
      .catch(function () { nativePost(c.id, c.qty, c.mode); });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-flf-atc]');
    if (!b) return;
    e.preventDefault();
    add(b);
  });

  // Option cards: highlight + sync sticky label
  d.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('input[data-flf-opt]')) return;
    var o = r.closest('[data-flf-offer]');
    o.querySelectorAll('.flf-opt').forEach(function (l) { l.classList.toggle('is-on', l.contains(r) && r.checked); });
    var lbl = r.getAttribute('data-sticky');
    d.querySelectorAll('[data-flf-sticky-text]').forEach(function (s) {
      if (!s.hasAttribute('data-default')) s.setAttribute('data-default', s.innerHTML);
      s.innerHTML = lbl ? lbl : s.getAttribute('data-default');
    });
  });

  // Sticky bar: visible after X % scroll depth, hidden while buy box is on screen
  function initSticky() {
    var s = d.querySelector('[data-flf-sticky]');
    if (!s || s.__flf) return;
    s.__flf = 1;
    var th = (parseFloat(s.getAttribute('data-threshold')) || 30) / 100;
    var hideOnOffer = s.getAttribute('data-hide-offer') === 'true';
    var inOffer = false, ticking = false;
    function upd() {
      ticking = false;
      var h = d.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? window.scrollY / h : 0;
      s.classList.toggle('is-on', p >= th && !(hideOnOffer && inOffer));
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    var o = d.querySelector('[data-flf-offer] .flf-o-buy') || offerEl();
    if (hideOnOffer && o && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inOffer = en[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(o);
    }
    upd();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', initSticky); else initSticky();
  d.addEventListener('shopify:section:load', initSticky);

  window.flFit = { add: add };
})();
